module.exports = __webpack_public_path__ + "a9f9ce314a89869fd1f17ee74cdfe7a6.jpg";